// src/app/savings-calculator/savings-calculator.component.ts
import { Component, Input, OnInit, signal, computed, Inject, model } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NextEvent } from '../../models/dfs-events.models';
import { MatSliderModule } from '@angular/material/slider';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
@Component({
  selector: 'app-savings-calculator',
  templateUrl: './savings-calculator.component.html',
  styleUrls: ['./savings-calculator.component.scss'],
  standalone: true,
  imports: [
    MatSliderModule,
    MatCardModule,
    MatButtonModule,
    CommonModule,
    FormsModule
  ],
})
export class SavingsCalculatorComponent implements OnInit {
   // Input property for nextEvent
   @Input() nextEvent?: NextEvent;

   // Signal to hold the currentUsage percentage
   currentUsage = model<number>(50); // Default to 50%

   reducedUsage = computed(() => {
      if (this.nextEvent) {
        const usageFraction = this.currentUsage() / 100;
        return this.nextEvent.expectedUsage * usageFraction;
      }
      return 0;
   });
 
   // Computed signal to calculate savings
   savings = computed(() => {
     if (this.nextEvent) {
       const usageFraction = this.currentUsage() / 100;
       return this.nextEvent.expectedUsage * usageFraction * this.nextEvent.earningsPerKW;
     }
     return 0;
   });
 
   constructor() { }
 
   ngOnInit(): void { }

   formatLabel(value: number) {
      return value + '%';
  }
}



@Component({
  selector: 'app-savings-calculator-dialog',
  template: `
    <h2 mat-dialog-title>Savings Calculator</h2>
    <mat-dialog-content>
      <app-savings-calculator
        [nextEvent]="data.nextEvent"
      ></app-savings-calculator>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button mat-dialog-close>Close</button>
    </mat-dialog-actions>
  `,
  imports: [SavingsCalculatorComponent, MatDialogModule, MatButtonModule],
})
export class SavingsCalculatorDialogComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { nextEvent: NextEvent }) {}

  ngOnInit(): void {}
}
